import { useEffect } from 'react';
import { create } from 'zustand';

const searchParams = new URLSearchParams(window.location.search);
const themeKey = 'theme';

const useStore = create((set) => ({
  theme: searchParams.get(themeKey) ?? 'dark',
  setTheme: (value) => set(() => ({ theme: value })),
}));

const useTheme = () => {
  const { theme, setTheme } = useStore();

  useEffect(() => {
    const htmlElement = document.documentElement;
    htmlElement.className = `${theme}-mode`;
  }, [theme]);

  return {
    theme,
    setTheme,
    themeKey,
  };
};

export default useTheme;
